import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <header className="redo-header">
      <div className="redo-header-content">
        {/* LEFT: Brand (logo + text) */}
        <a
          className="redo-header-brand"
          href="https://redostar.com"
          aria-label="Go to redostar.com"
        >
          <img
            src="favicon.png"
            alt="ReDo Logo"
            className="redo-header-logo"
          />
          <div className="redo-header-brand-block">
            <div className="redo-header-title">ReDo</div>
            <div className="redo-header-powered">
              <img
                src="/Tlogo.png"
                alt=""
                className="thumbtack-powered-logo"
              />
              Powered by <b>Thumbtack</b>
            </div>
          </div>
        </a>

        {/* RIGHT: Call button */}
        <div className="redo-header-right">
          <a
            className="redo-header-call-btn"
            href="tel:+18886426266"
            aria-label="Call 1-888-642-6266"
          >
            1-888-642-6266
          </a>
        </div>
      </div>
    </header>
  );
}
